export enum AppName {
  Pflegia = 'Pflegia',
  Praxia = 'Praxia',
  Docia = 'Docia',
}
